import React, {useEffect, useState} from "react";
import {
  apollo_useStyles,
  valueToOption,
  options_platformdetail_path,
  options_state_new,
  options_approval_new, options_state_edit,
} from "../../atom/Apollo_styles";
import {
  accountdetailapollo_path,
  apollo_account_platform_path,
  apollo_menu_master_path,
} from "../../atom/Apollo_links";
import {APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_OPERATOR, IsAuthorization} from "../../atom/Apollo_Authorization";
import {STORAGE_KEY} from "../../atom/Apollo_DataTable";

import {AccountGroup, Account, isEnablePlatform, GetMenuStatus} from "./AccountModel";
import {MenuCampaignMaster} from "../MASTER/Apollo_MasterModel";
import {useHistory} from "react-router-dom";
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {MUISortOptions, SelectableRows} from "mui-datatables";
import {ApolloDataTable} from "../../atom/Apollo_DataTable";
import {
  APOLLO_PAGE_ID,
  getApolloPageSizeSetting,
  saveApolloPageSizeSetting,
} from "../../common/Apollo_LocalStorageSettings";
import Card from "@material-ui/core/Card/Card";
import {
  AccountColumns,
  AccountGroupColumns,
  AccountSummaryColumns,
  CsvData,
  DefaultMenuMaster
} from "../../common/Apollo_CommonConst";
import {valueToLabel} from "../../common/Apollo_CommonUtil";
// メッセージ定義
import {
  GetMessage,
  UI_ACCOUNT_LIST,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

/*
    アカウントリスト表示
 */
const ApolloAccountList = (props: { row: AccountGroup | undefined, seni: string }) => {
  const {row} = props;
  const classes = apollo_useStyles();
  const [menus, setMenus] = useState<MenuCampaignMaster[]>([]);
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [numberOfRows, setNumberOfRows] = useState(
    getApolloPageSizeSetting(APOLLO_PAGE_ID.ACCOUNT_GROUP_ACCOUNTS)
  );
  const {state, dispatch} = React.useContext(ApolloContext);
  const history = useHistory();
  const {data, setmsg} = React.useContext(ApolloMessage);
  const isAgencyRole = !IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_OPERATOR);

  useEffect(() => {
    // メニュー名称取得
    const path = apollo_menu_master_path;
    ApolloAxios.get(path).then(response => {
      if (response.data.resultCode === 0) {
        setMenus(response.data.result);
      } else {
        console.log(response.data.message)
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_ACCOUNT_LIST,"E","0"),
            loading: false,
          }
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_LIST,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });

    // アカウントリスト取得
    const pathAccount = apollo_account_platform_path + "/" + row?.accountgroupId;
    ApolloAxios.get(pathAccount).then(response => {
      if (response.data.resultCode === 0) {
        if (isAgencyRole) {
          const accountRows = [];
          for (const accountRow of response.data.result) {
            if (accountRow.status !== 3 && accountRow.approval === 2) {
              accountRows.push(accountRow);
            }
          }
          setAccounts(accountRows);
        } else {
          setAccounts(response.data.result);
        }
      } else {
        console.log(response.data.message);
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_ACCOUNT_LIST,"E","1"),
            loading: false,
          }
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_LIST,"E","1"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, []);

  const handleClickOpen = (accountgroupId: number, accountgroupName: string, accountId: number, accountName: string) => {
    //コンテキストを更新
    var roleAuthorization = 0
    var customSegment = 1
    var geoSegment = 1
    state.apolloList.find((v) => {
      if (v.accountGroup.id === accountgroupId) {
        roleAuthorization = v.accountGroup.roleAuthorization;
        customSegment = v.accountGroup.customSegment;
        geoSegment = v.accountGroup.geoSegment;
      }
    })
    dispatch({
      type: "changeAccount",
      payload: {
        ...state,
        current: {
          ...state.current,
          accountGroupId: accountgroupId,
          accountGroupName: accountgroupName,
          accountId: accountId,
          accountName: accountName,
          roleAuthorization: roleAuthorization,
          customSegment: customSegment,
          geoSegment: geoSegment,
        }
      }
    });
    //画面遷移
    history.push(accountdetailapollo_path + accountgroupId + "/" + accountId + "?type=" + props.seni)
  }

  const handleClickPlatformOpen = (accountgroupId: number, accountgroupName: string, accountId: number, accountName: string, platformId: number, platformAccountId: string) => {
    //コンテキストを更新
    var roleAuthorization = 0
    var customSegment = 1
    var geoSegment = 1
    state.apolloList.find((v) => {
      if (v.accountGroup.id === accountgroupId) {
        roleAuthorization = v.accountGroup.roleAuthorization;
        customSegment = v.accountGroup.customSegment;
        geoSegment = v.accountGroup.geoSegment;
      }
    })
    const path = valueToOption(platformId, options_platformdetail_path);
    dispatch({
      type: "changeAccount",
      payload: {
        ...state,
        current: {
          ...state.current,
          accountGroupId: accountgroupId,
          accountGroupName: accountgroupName,
          accountId: accountId,
          accountName: accountName,
          // trackerId: trackerId,
          roleAuthorization: roleAuthorization,
          customSegment: customSegment,
          geoSegment: geoSegment,
        }
      }
    });
    history.push(path.label + accountgroupId + "/" + accountId + "/" + platformAccountId)
  }

  // メニューリスト
  const columns2 = menus.map((menu, index) => {

    return {
      name: "",
      label: menu.menuName,
      options: {
        setCellProps: () => ({
          align: "center"
        }),
        filter: true,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          var platformId = 0;
          var platformAccountId = "";
          accounts[idx].platformAccounts &&
          accounts[idx].platformAccounts.map((platform, _) => {
            if (Number(platform.platformId) === menu.menuId) {
              platformId = platform.platformId;
              platformAccountId = platform.id;
            }
            return null;
          })
          return (
            accounts[idx].platformAccounts &&
            isEnablePlatform(accounts[idx].useMenus, menu) ?
              <div className={classes.pointer}
                   onClick={() => handleClickPlatformOpen(
                     (row?.accountgroupId ? row?.accountgroupId : 0),
                     (row?.accountgroupName ? row?.accountgroupName : ""),
                     accounts[idx].accountId,
                     accounts[idx].accountName,
                     platformId,
                     platformAccountId,
                   )}>
                {GetMenuStatus(accounts[idx].useMenus, menu)}
              </div>
              : GetMenuStatus(accounts[idx].useMenus, menu)
          )
        },
      },
    }
  });

  // 最初のリストオプション
  var columns1 = [
    {
      name: "accountId",
      label: "広告主アカウントID",
      options: {
        display: false,
        filter: true,
        sort: true,
      }
    },
    {
      name: "accountName",
      label: "広告主アカウント名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "budgetAmount",
      label: "当月予算",
      options: {
        setCellProps: () => ({
          align: "right"
        }),
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return value ? value.toLocaleString() : 0;
        },
      },
    },
    {
      name: "advertiserName",
      label: "広告主名",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return value ? valueToOption(value, options_state_new).label : ""
        },
      },
    },
    {
      name: "approval",
      label: "承認状況",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return value ? valueToOption(value, options_approval_new).label : ""
        },
      },
    },
  ];

  // 最後のリストオプション
  const columns3 = [
    {
      name: "",
      label: "詳細",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <KeyboardArrowRightIcon
              onClick={() => handleClickOpen((row?.accountgroupId ? row.accountgroupId : 0), (row?.accountgroupName ? row.accountgroupName : ""), accounts[idx].accountId, accounts[idx].accountName)}
              style={{cursor: "pointer"}}/>
          );
        },
      },
    },
  ];

  columns2.map((column) => {
    // @ts-ignore
    columns1.push(column);
    return null;
  });

  columns3.map((column) => {
    columns1.push(column);
    return null;
  });

  const sortOrder: MUISortOptions = {
    name: "accountId",
    direction: 'desc',
  };

  const selectableRows: SelectableRows = 'none';

  const options = {
    filter: true,
    downloadOptions: {
      filename: `accounts.csv`,
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      const csvData = formatCsvData(data, accounts, menus);
      return "\uFEFF" + buildHead(AccountColumns) + buildBody(csvData);
    },
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.APOLLO_ACCOUNT_LIST) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: numberOfRows,
    jumpToPage: true,
    expandableRows: false,
    storageKey: STORAGE_KEY.APOLLO_ACCOUNT_LIST,
    onChangeRowsPerPage: (numberOfRows: number) => {
      saveApolloPageSizeSetting(APOLLO_PAGE_ID.ACCOUNT_GROUP_ACCOUNTS, numberOfRows);
      setNumberOfRows(numberOfRows);
    },
  }

  return (
    <Card className={classes.root} square variant="outlined">
      <ApolloDataTable
        title=""
        data={accounts}
        columns={columns1}
        options={
          {
            ...options,
            textLabels: {
              body: {noMatch: "該当データが存在しません"}
            },
          }
        }
      />
    </Card>
  );
}

const formatCsvData = (data: any[], tableData: Account[], menus: MenuCampaignMaster[]): CsvData[] => {
  const dataList: CsvData[] = [];
  let optimizeData: MenuCampaignMaster = DefaultMenuMaster;
  let mailData: MenuCampaignMaster = DefaultMenuMaster;

  menus?.map((menu) => {
    switch (menu.menuId) {
      case 1:
        optimizeData = menu;
        break;

      case 2:
        mailData = menu;
        break;

      default:
        break;
    }
  });

  data?.map((v: { index: any, data: any[] }) => {
      if (!v.data || v.data.length === 0) return;
      const values = tableData.filter((td) => td.accountId === v.data[0]);
      if (!values || values.length === 0) return;
      const d = values[0];


      const list: CsvData = {
        index: v.index,
        data: [
          d.accountId,
          d.accountName,
          `￥${d.budgetAmount !== undefined? d.budgetAmount: 0}`,
          d.advertiserName,
          valueToLabel(d.status, options_state_edit),
          valueToLabel(d.approval, options_approval_new),
          GetMenuStatus(d.useMenus, optimizeData),
          GetMenuStatus(d.useMenus, mailData),
        ],
      };
      dataList.push(list);
    }
  );
  return dataList;
}

export default ApolloAccountList;
